<script lang="ts">
	import { Currency, type Currency$options } from '$houdini';
	import Input from '$lib/components/atoms/input/Input.svelte';
	import Select from '$lib/components/atoms/select/Select.svelte';
	import SkeletonInput from '$lib/components/atoms/skeleton/SkeletonInput.svelte';
	import { getCurrencyOptions } from '$lib/components/itinerary/tripOptions';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	interface Props {
		isEV?: boolean;
		loading?: boolean;
		onCurrencyChange?: () => void;
	}

	const { isEV = false, loading = false, onCurrencyChange }: Props = $props();

	const { tripOptionsStore } = getMapLayoutContext();

	function handlePriceChange(event: Event) {
		const eventTarget = event.target as HTMLInputElement;
		const energyPrice = Number.parseFloat(eventTarget.value.replace(',', '.'));
		$tripOptionsStore.energyPrice = typeof energyPrice === 'number' && energyPrice > 0 ? energyPrice : undefined;

		track({
			action: 'price_setup',
			payload: {
				action: 'click',
				[isEV ? 'price_kwh' : 'price_fuel']: energyPrice,
			},
		});
	}

	function handleCurrencyChange(currency: Currency$options) {
		$tripOptionsStore.currency = currency;
		onCurrencyChange?.();

		if (isEV) {
			track({
				action: 'electric_setup',
				payload: {
					action: 'selection',
					user_currency: $tripOptionsStore.currency.toUpperCase(),
				},
			});
		}
	}

	const label = $derived(isEV ? m.itinerary__options__kwh__price() : m.itinerary__options__fuel__price());
	const energyPrice
		= $derived(typeof $tripOptionsStore.energyPrice === 'number'
			? $tripOptionsStore.energyPrice.toString()
			: '');
</script>

<div class="flex gap-2">
	<div class="flex flex-col w-30">
		{#if loading}
			<SkeletonInput {label} />
		{:else}
			<Input
				{label}
				id="energy-price"
				value={energyPrice}
				ariaLabel={label}
				onchange={handlePriceChange}
			/>
		{/if}
	</div>

	<div class="w-30">
		<Select
			label={m.itinerary__options__currency()}
			options={getCurrencyOptions()}
			defaultValue={$tripOptionsStore.currency}
			ariaLabel={m.itinerary__options__currency()}
			onSelectedChange={currency => handleCurrencyChange(currency ?? Currency.eur)}
		/>
	</div>
</div>
